import Yup from './customValidators';

/**
 * Validation schemas for forms
 */

// Phone number schema
export const phoneSchema = Yup.object({
    phoneNumber: Yup.string()
        .required('شماره موبایل الزامی است')
        .mobileNumber(),
});

// OTP verification schema
export const otpSchema = Yup.object({
    code: Yup.string()
        .required('کد تایید الزامی است')
        .matches(/^\d{6}$/, 'کد تایید باید 6 رقم باشد'),
});

// MFA second-factor code schema (TOTP 6 digits or 12-char recovery code)
export const mfaCodeSchema = Yup.object({
    code: Yup.string()
        .required('کد الزامی است')
        .matches(/^[A-Za-z0-9-]{6,18}$/, 'کد معتبر نیست'),
});

// User profile schema
export const profileSchema = Yup.object({
    firstName: Yup.string()
        .required('نام الزامی است')
        .min(2, 'نام باید حداقل 2 کاراکتر باشد')
        .max(50, 'نام نباید بیشتر از 50 کاراکتر باشد'),

    lastName: Yup.string()
        .required('نام خانوادگی الزامی است')
        .min(2, 'نام خانوادگی باید حداقل 2 کاراکتر باشد')
        .max(50, 'نام خانوادگی نباید بیشتر از 50 کاراکتر باشد'),

    nationalCode: Yup.string()
        .required('کد ملی الزامی است')
        .nationalCode(),

    birthDate: Yup.string()
        .required('تاریخ تولد الزامی است')
        .persianDate()
        .minAge(18, 'سن باید حداقل 18 سال باشد'),
});

// Admin login schema
export const adminLoginSchema = Yup.object({
    username: Yup.string()
        .required('نام کاربری الزامی است')
        .min(3, 'نام کاربری باید حداقل 3 کاراکتر باشد'),

    password: Yup.string()
        .required('رمز عبور الزامی است')
        .min(6, 'رمز عبور باید حداقل 6 کاراکتر باشد'),
});

// Certificate issuance schema
export const certificateSchema = Yup.object({
    commonName: Yup.string()
        .required('نام مشترک الزامی است')
        .min(2, 'نام مشترک باید حداقل 2 کاراکتر باشد'),

    organization: Yup.string()
        .required('نام سازمان الزامی است'),

    organizationalUnit: Yup.string(),

    country: Yup.string()
        .required('کشور الزامی است')
        .length(2, 'کد کشور باید 2 کاراکتر باشد'),

    state: Yup.string(),

    locality: Yup.string(),

    email: Yup.string()
        .email('ایمیل نامعتبر است'),

    validityDays: Yup.number()
        .required('مدت اعتبار الزامی است')
        .min(1, 'مدت اعتبار باید حداقل 1 روز باشد')
        .max(3650, 'مدت اعتبار نباید بیشتر از 10 سال باشد'),
});

// Operator review schema
export const operatorReviewSchema = Yup.object({
    status: Yup.string()
        .required('وضعیت الزامی است')
        .oneOf(['approved', 'rejected'], 'وضعیت باید تایید یا رد باشد'),

    comment: Yup.string()
        .when('status', {
            is: 'rejected',
            then: (schema) => schema.required('دلیل رد الزامی است'),
            otherwise: (schema) => schema,
        }),
});

// Change password schema
export const changePasswordSchema = Yup.object({
    currentPassword: Yup.string()
        .required('رمز عبور فعلی الزامی است'),

    newPassword: Yup.string()
        .required('رمز عبور جدید الزامی است')
        .min(8, 'رمز عبور باید حداقل 8 کاراکتر باشد')
        .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
            'رمز عبور باید شامل حروف بزرگ، کوچک و عدد باشد'
        ),

    confirmPassword: Yup.string()
        .required('تکرار رمز عبور الزامی است')
        .oneOf([Yup.ref('newPassword')], 'رمز عبور و تکرار آن باید یکسان باشند'),
});

export default {
    phoneSchema,
    otpSchema,
    profileSchema,
    adminLoginSchema,
    certificateSchema,
    operatorReviewSchema,
    changePasswordSchema,
};
